const getRegexByConditions = (
    integerOnly,
    onlyPositiveNumbers,
    scientificNotation,
) => {
    if (integerOnly) {
        return /^(\d+|\s)$/m;
    }
    if (onlyPositiveNumbers) {
        if (scientificNotation) {
            return /^(\d+|\d+\.\d+|\d+\.)?(\d+[eE][-+]?|\d+[eE][-+]?\d+)?$/m;
        }
        return /^(\d+|\d+\.\d+|\d+\.)?(\d+)?$/m;
    }
    if (scientificNotation) {
        return /^-?(\d+|\d+\.\d+|\d+\.)?(\d+[eE][-+]?|\d+[eE][-+]?\d+)?$/m;
    }
    return /^-?(\d+|\d+\.\d+|\d+\.)?(\d+)?$/m;
};

/**
 * Converts and validates a string entry as a number with optional decimal/integer/scientific constraints.
 *
 * @param entry - The string value to convert and validate.
 * @param fallback - The value to return if the entry is invalid.
 * @param integerOnly - Whether to restrict the value to integers only.
 * @param decimalDigits - The maximum number of decimal digits allowed.
 * @param onlyPositiveNumbers - Whether to restrict the value to positive numbers only.
 * @param scientificNotation - Whether to allow scientific notation (e.g., 1e10).
 * @returns The validated and converted value, or the fallback if invalid.
 */
export const convert = (
    entry,
    fallback,
    integerOnly,
    decimalDigits = 0,
    onlyPositiveNumbers = false,
    scientificNotation = undefined,
) => {
    let value = entry;
    if (
        value &&
        value.split(".")[1] &&
        value.split(".")[1].length > decimalDigits
    ) {
        const values = value.split(".");
        values[1] = values[1].substring(0, decimalDigits);
        value = values.join(".");
    }
    const numberRegex = getRegexByConditions(
        integerOnly,
        onlyPositiveNumbers,
        scientificNotation,
    );
    const isNan = !numberRegex.test(value);
    if (isNan && !!value) {
        value = fallback;
    } else if (integerOnly && (!value || value === "0")) {
        value = "";
    }

    if (entry.indexOf(".") === 0) {
        value = "0" + entry;
    } else if (
        (value === "0" && fallback !== "0.") ||
        (!value &&
            value.indexOf(".") > 0 &&
            value.indexOf(".") === value.length - 1)
    ) {
        value += ".";
    }

    return value;
};
